import { render, staticRenderFns } from "./ActionTypeAdd.vue?vue&type=template&id=5787bffd&scoped=true"
import script from "./ActionTypeAdd.vue?vue&type=script&lang=js"
export * from "./ActionTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./ActionTypeAdd.vue?vue&type=style&index=0&id=5787bffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787bffd",
  null
  
)

export default component.exports